import { useEffect, useState } from "react";
import { useLocation, Routes, Route } from "react-router-dom";
import WOW from "wow.js";
import CreativeAgency from "./pages/Home/CreativeAgency";
import PersonalPortfolio from "./pages/Home/PersonalPortfolio";
import DigitalAgency from "./pages/Home/DigitalAgency";
import AboutUs from "./pages/About/AboutUs";
import AboutMe from "./pages/About/AboutMe";
import TeamPage from "./pages/Team/TeamPage";
import TeamPageDetails from "./pages/Team/TeamPageDetails";
import PortfolioDetailsPage from "./pages/PortfolioDetailsPage";
import ServicesDetailsPage from "./pages/ServicesDetailsPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/Blog/BlogPage";
import BlogDetailsPage from "./pages/Blog/BlogDetailsPage";
import AnimatedCursor from "react-animated-cursor";
import Portfolio from "./pages/Portfolio/Portfolio";
import ServicesPage from "./pages/Services/ServicePage";
import DynamicServicesPage from "./pages/Services/DynamicServicesPage";
import Pricing from "./pages/Pricing/pricing";
import WebsiteForm from "./pages/WebsiteForm/WebsiteForm";
import LogoForm from "./pages/LogoForm/LogoForm";
import Package from "./pages/Combo-Packages/package";
import PrivacyPolicy from "./pages/PrivacyPolicy/privacy-policy";
import SeoQuestionnaireForm from "./pages/SEO Questionnaire Form/seo-questionnaire-form";
import WebDesign from "./pages/Web_Design/web_design";
import PageNotFound from "./pages/PageNotFound/pagenotfound";
import ScrollAnimation from "./pages/Dummy/ScrollAnimation";
import Appointment from "./pages/Appointment/Appointment";

function App() {
  useEffect(() => {
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: false,
      live: true,
    });
    wow.init();
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <AnimatedCursor
        innerSize={8}
        outerSize={32}
        color="248, 82, 207"
        outerAlpha={0.15}
        innerScale={0}
        outerScale={0}
        clickables={[
          "a",
          'input[type="text"]',
          'input[type="email"]',
          'input[type="number"]',
          'input[type="submit"]',
          'input[type="image"]',
          "label[for]",
          "select",
          "textarea",
          "button",
          ".link",
        ]}
      />

      <Routes>
        <Route path="/" element={<CreativeAgency />} />


        
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:service" element={<WebDesign />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/website-form" element={<WebsiteForm />} />
        <Route path="/logo-form" element={<LogoForm />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/combo-packages" element={<Package />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/seo-questionnaire-form"
          element={<SeoQuestionnaireForm />}
        />
        <Route path="*" element={<PageNotFound />} />
        {/* <Route path="/animation" element={<ScrollAnimation />} /> */}
      </Routes>
    </>
  );
}

export default App;

// template_d7ue7yd
